export default __webpack_public_path__ + "static/media/gallery - story - hand (1)_03.e1f62ea9.jpg";